"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = exports.content = exports.removeButtonIcon = exports.button = exports.animatedBg = void 0;

var _util = require("../../../util");

const animatedBg = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'background.default')
});

exports.animatedBg = animatedBg;

const button = ({
  theme,
  cssProps: {
    expanded = false
  }
}) => ({
  background: (0, _util.color)(theme, 'background.orange'),
  height: '100%',
  maxWidth: expanded ? 200 : 0,
  transition: '0.2s',
  overflow: 'hidden'
});

exports.button = button;

const removeButtonIcon = ({
  cssProps: {
    expanded = false
  }
}) => ({
  maxWidth: expanded ? 0 : 32,
  transition: '0.2s'
});

exports.removeButtonIcon = removeButtonIcon;

const content = ({
  theme,
  cssProps: {
    expanded = false
  }
}) => ({
  whiteSpace: 'nowrap',
  width: '100%',
  flexShrink: expanded ? 1 : 0,
  background: (0, _util.color)(theme, 'background.default'),
  height: '100%',
  right: 0,
  zIndex: 1
});

exports.content = content;

const root = ({
  cssProps: {
    disabled
  }
}) => ({
  overflow: 'hidden',
  position: 'relative',
  zIndex: 0,
  pointerEvents: disabled ? 'none' : 'initial'
});

exports.root = root;
//# sourceMappingURL=EditableListItem.style.js.map